import { render, staticRenderFns } from "./Ingredients.vue?vue&type=template&id=8c7105e8&scoped=true"
import script from "./Ingredients.vue?vue&type=script&lang=js"
export * from "./Ingredients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7105e8",
  null
  
)

export default component.exports